import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline} from '@mui/material';
import { useMediaQuery} from '@mui/material';
import { useAppSelector } from '@/hooks/redux';
import { lightTheme, darkTheme } from '@/theme';

interface ThemeProviderWrapperProps {
  children: React.ReactNode;
}

export const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = ({ children }) => {
  const themePreference = useAppSelector((state) => state.ui.theme);
  const systemPrefersDark = useMediaQuery('(prefers-color-scheme: dark)');

  const resolvedTheme = useMemo(() => {
    if (themePreference === 'system') {
      return systemPrefersDark ? darkTheme : lightTheme;
    }
    return themePreference === 'dark' ? darkTheme : lightTheme;
  }, [themePreference, systemPrefersDark]);

  return (
    <MuiThemeProvider theme={resolvedTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProviderWrapper;